import React, { useState } from 'react'

import './menuSeatGate.scss'

function LocationIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M12 21s7-4.35 7-10a7 7 0 1 0-14 0c0 5.65 7 10 7 10Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <circle cx="12" cy="11" r="2.5" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  )
}

function LockIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <rect
        x="5"
        y="11"
        width="14"
        height="10"
        rx="2"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M8 11V8a4 4 0 0 1 8 0v3"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default function MenuSeatGate({
  sectionName,
  initialRow = '',
  initialSeat = '',
  onContinue,
}) {
  const [row, setRow] = useState(initialRow)
  const [seat, setSeat] = useState(initialSeat)
  const [remember, setRemember] = useState(true)

  const canContinue = row.trim().length > 0 && seat.trim().length > 0

  const handleSubmit = (event) => {
    event.preventDefault()
    if (!canContinue) return
    onContinue({ row, seat, remember })
  }

  return (
    <div className="menu-seat-gate">
      <div className="menu-seat-gate__backdrop" />
      <form className="menu-seat-gate__card" onSubmit={handleSubmit}>
        <div className="menu-seat-gate__header">
          <LocationIcon />
          <span>Scanned at this section</span>
        </div>

        <div className="menu-seat-gate__section">
          <span>{sectionName}</span>
          <LockIcon />
        </div>

        <p className="menu-seat-gate__prompt">What&apos;s your row and seat?</p>

        <div className="menu-seat-gate__fields">
          <label className="menu-seat-gate__field">
            <span>Row</span>
            <input
              type="text"
              value={row}
              onChange={(event) => setRow(event.target.value)}
              placeholder="F"
              autoComplete="off"
              autoFocus
            />
          </label>
          <label className="menu-seat-gate__field">
            <span>Seat</span>
            <input
              type="text"
              value={seat}
              onChange={(event) => setSeat(event.target.value)}
              placeholder="8"
              autoComplete="off"
            />
          </label>
        </div>

        <label className="menu-seat-gate__remember">
          <input
            type="checkbox"
            checked={remember}
            onChange={(event) => setRemember(event.target.checked)}
          />
          <span>Remember for this visit</span>
        </label>

        <button
          type="submit"
          className="menu-seat-gate__continue"
          disabled={!canContinue}
        >
          Continue to menu
        </button>
      </form>
    </div>
  )
}
